import { apiClient } from './client';
import type { DashboardStatsResponse } from '@/types';

export const dashboardAPI = {
  getStats: () => 
    apiClient.get<DashboardStatsResponse>('/dashboard/stats'),
};